<template>
  <a-modal
    title="修改项目信息"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :footer="null"
    :destroyOnClose="true"
    @ok="handleOk"
    @cancel="handleCancel"
    center
    width="600px"
  >
    <div class="popup-class">
      <div class="modify-class">
        <span>项目名称:</span>
        <div class="select-tags"><a-input v-model="data.projectName" /></div>
      </div>
      <div class="modify-class">
        <span>项目描述:</span>
        <div class="select-tags">
          <a-textarea v-model="data.projectDescription" />
        </div>
      </div>
      <div class="modify-class">
        <span>框架选择:</span>
        <div class="select-tags">
          <a-cascader 
            style="width: 100%;text-align: center;"
            :display-render="displayRender"
            v-model="data.frameworkId" 
            :fieldNames="{label: 'name', value: 'id', children: 'children'}" 
            placeholder="请选择项目框架" 
            :options="frameworkOptions" change-on-select />
        </div>
      </div>
      <div class="modify-class">
        <span>项目版本号:</span>
        <div class="select-tags">
          <a-input v-model="data.version"></a-input> 
        </div>
      </div>
      <div class="modify-class">
        <span>标签:</span>
        <div class="select-tags">
          <SelectTags @getTags="tagsArr" @tagFocus="getTagParams" :queryParams="tagParams"/>
        </div>
      </div>
      <div class="modify-class">
        <span>项目权限:</span>
        <div class="select-tags">
          <PermissionsChoose/>
        </div>
      </div>
    </div>
    <div class="popup-foot">
      <a-button class="button-cancel" @click="cancel" type="primary"
        >取消</a-button
      >
      <a-button type="primary" @click="save">保存</a-button>
    </div>
  </a-modal>
</template>
<script>
import SelectTags from '../components/SelectTags'
import frameworkApi from "@/request/api-manager/framework.js";
import PermissionsChoose from '@/views/component/permissionsChoose/index'
export default {
  name: "modal",
  props: {
    tags: {
      type: Array,
    },
    visible: {
      type: Boolean,
    },
    confirmLoading: {
      type: Boolean,
    },
    editData:{
      type:Object
    }
    // nameValue:{
    //   type: String,
    // },
    // addressValue:{
    //   type: String,
    // },
    // describeValue:{
    //   type: String,
    // }
  },
  components: {
    SelectTags,
    PermissionsChoose
  },
  data() {
    return {
      headers: {
        authorization: "authorization-text",
      },
      data:{},
      tagsArrOptions:[],
      tagParams:{},
      frameworkOptions: []
    };
  },
  watch: {
    editData(value){
      if(value.frameworkId){
        frameworkApi.getParentIdsById({frameworkId: value.frameworkId}).then(res => {
          console.log('res', res)
          value.frameworkId = res.result.reverse()
          this.data = JSON.parse(JSON.stringify(value))
        })
      }else{
        this.data = JSON.parse(JSON.stringify(value))
      }
    }
  },
  mounted() {
    this.getFrameworkTree()
  },
  methods: {
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },
    getFrameworkTree() {
      frameworkApi.listAll().then(res => {
        console.log('res', res)
        this.frameworkList = res.result
        let frameworkOptions = {id: null}
        this.getChildren(frameworkOptions)
        this.frameworkOptions = frameworkOptions.children
        console.log('option', this.frameworkOptions)
        // _(res.result).filter(item => tem.parentId == null).each
      })
    },
    getChildren(obj){
      obj.children = _.filter(this.frameworkList, item => item.parentId == obj.id)
      if(obj.children.length > 0){
        obj.children.forEach(item => {
          this.getChildren(item)
        })
      }
    },
    handleOk() {
      this.$emit("handleOk");
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    handleChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    save() {
      let {id,frameworkId, projectName,projectDescription,version,projectImage} = this.data
      let editParams = {
        id,
        frameworkId: frameworkId[frameworkId.length-1],
        name:projectName,
        version:version,
        description:projectDescription,
        img:projectImage
      }
      this.$emit("save",editParams);
    },
    cancel() {
      this.$emit("cancel");
    },
    tagsArr(val){
      this.tagsArrOptions = val
    },
    /**
     * 选中的标签
     * @param {Array} params 选中的数组
     */ 
    getTags(params){
      console.log(params,"getTags-params")
    },
    /**
     * 获取请求的参数
     */
    getTagParams(){
      this.tagParams = {
        dataType:'project',
        params:{
          pageNo:1,
          pageSize:10,
          column:'num',
          order:'desc',
          type:0
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./modal.less";
</style>